import React, { SetStateAction, Dispatch, useState, Fragment } from 'react';

import { X } from 'lucide-react';

import { AppConfig } from '../../../../config/app.config';

import { useUpdatePilotContact } from '../../../../hooks/mbts_consents';

import { CookiesHelper } from '../../../../helpers/cookies.helper';

interface PilotContactProps {
    isVisible: boolean;
    setIsVisible: Dispatch<SetStateAction<boolean>>;
};

export const PilotContact = (props: PilotContactProps) => {
    const { isVisible, setIsVisible } = props;

    const [isTrueProcessing, setIsTrueProcessing] = useState<boolean>(false);
    const [isFalseProcessing, setIsFalseProcessing] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    const { mutate: updatePilotContact } = useUpdatePilotContact();

    const onClose = () => {
        setIsVisible(false);
    };

    const onUpdatePilotContact = (action: boolean) => {
        if (action ? isTrueProcessing : isFalseProcessing) return;

        const consentToken = CookiesHelper.get(AppConfig.cookieTokenNames.mbtsConsent);
        if (!consentToken) return;

        updatePilotContact({
            payload: {
                pilot_contact: action,
                token: consentToken,
            },
            setIsProcessing: action ? setIsTrueProcessing : setIsFalseProcessing,
            setError,
            setIsSuccess,
        });
    };

    return (
        <div className={`mbts_analysis__pilot_contact ${isVisible ? 'mbts_analysis__pilot_contact--visible' : ''}`}>
            <div className='card card--md card--radius-md mbts_analysis__pilot_contact__content'>
                {isSuccess && (
                    <Fragment>
                        <p className="text-lg text-semibold color--success text-center">Thank you for your response!</p>
                        <p className="color--txt-muted text-center mb-2xl">You can now close this window.</p>
                        <button className="btn btn--fluid btn--md btn--radius-md btn--primary" onClick={onClose}>Close</button>
                    </Fragment>
                )}
                {!isSuccess && (
                    <Fragment>
                        <button className="mbts_analysis__pilot_contact__close" onClick={onClose}>
                            <X />
                        </button>
                        <p className="text-semibold text-lg text-center mt-xl">Would you like to explore this technology further?</p>
                        <p className="color--txt-muted text-center mb-2xl">We will use your email address to contact you.</p>
                        <div className="mbts_analysis__pilot_contact__actions">
                            <button className="btn btn--fluid btn--md btn--radius-md btn--primary" onClick={() => onUpdatePilotContact(true)}>
                                {isTrueProcessing
                                    ? <span className='btn-loader' />
                                    : <span>Yes, allow contact</span>
                                }
                            </button>
                            <button className="btn btn--fluid btn--md btn--radius-md btn--secondary" onClick={() => onUpdatePilotContact(false)}>
                                {isFalseProcessing
                                    ? <span className='btn-loader' />
                                    : <span>No, do not allow contact</span>
                                }
                            </button>
                        </div>
                        {error && (
                            <p className="text-sm color--error text-center mt-xs">{error}</p>
                        )}
                    </Fragment>
                )}
            </div>
        </div>
    );
};
